<template>
  <v-app v-resize="onResize">
    <core-drawer />
    <core-toolbar />
    <core-view />
  </v-app>
</template>
<script>
  export default {
    name: 'ProjectsViewerIndex',
    components: {
      //CoreToolbar,
      CoreToolbar: () => import('@/components/core/Toolbar.vue'),
      CoreDrawer: () => import('@/components/core/Drawer.vue'),
      CoreView: () => import('@/components/core/View.vue'),
    },
    data(){
      return {
        callInterval: 0
      }
    }, /*
    async mounted() {
      this.callInterval = setInterval(this.callData(),500)
     
      if(!this.$store.getters.isAuthenticated){
        const user = await this.$store.dispatch('getUser');
        if (user) {
          this.$store.commit('userAuthenticated', user)
        } else 
          this.$router.push('/redirect')
      }
      this.$extractions.getRole().then(response=>{
        this.$store.commit('setRole',response.data.role)
      }).catch(e=>{
        console.log('Error: ',e)
      })
        
    }, /**/ 
    beforeDestroy(){
      clearInterval(this.callInterval)
      this.callInterval = 0
      this.$store.commit('setPages',0)
      this.$store.commit('setResources',[])
    },
    computed: {
      windowSize:{
        get(){
          return this.$store.getters.getWindowSize
        },
        set(value){
          this.$store.commit('setWindowSize', value)
        }
      },
      breakpoint:{
        get(){
          return this.$vuetify.breakpoint
        }
      }
    },
    watch:{
      breakpoint: function(newval,oldval){
        if(newval===oldval){
          return null
        }
        this.$store.commit('setMobile',((this.$vuetify.breakpoint.name=="xs")||(this.$vuetify.breakpoint.name=="sm")))
      }
    },
    methods:{
      onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight}        
      },
      callData(){
        this.$store.dispatch('retrieveCameras')
      }
    }
  }
</script>